module.exports = __webpack_public_path__ + "static/cortex-about-froi-min-faac329c2a969a32ad306f9ddeedf0e8.png";